import type { GateType } from '../circuit/SignalState';

export function gateSymbol(type: GateType): string {
  const bubble = type === 'NAND' ? '<circle cx="154" cy="55" r="7" />' : '';
  const outputStart = type === 'NAND' ? 161 : 148;
  const shape = type === 'OR'
    ? '<path d="M44 22 Q78 55 44 88 Q100 94 148 55 Q100 16 44 22 M27 31 Q48 55 27 79" />'
    : '<path d="M45 20 L88 20 A35 35 0 0 1 88 90 L45 90 Z" />';
  return `<svg viewBox="0 0 190 110" aria-label="${type} 逻辑门符号">
    <g fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">
      ${shape}<path d="M8 38 H45 M8 72 H45 M${outputStart} 55 H182" />${bubble}
    </g>
  </svg>`;
}
